import Vue from "vue";

export default {
    getInstance(culture) {
        return new Vue({
            name: "entrances",
            el: ".entrances",
            data() {
                return {
                    slickOptions: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        dots: false,
                        arrows: true,
                        autoplay: false,
                        autoplaySpeed: 12500,
                        prevArrow: culture === "da-DK"
                            ? '<button class="slick-prev slick-arrow" aria-label="Tidligere" type="button"></button>'
                            : '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"></button>',
                        nextArrow: culture === "da-DK" 
                            ? '<button class="slick-next slick-arrow" aria-label="Næste" type="button"></button>'
                            : '<button class="slick-next slick-arrow" aria-label="Next" type="button"></button>',
                        responsive: [
                            {
                                breakpoint: 1024,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 2
                                }
                            },
                            {
                                breakpoint: 769,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1
                                }
                            }
                        ]
                    }
                };
            },
            // All slick methods can be used too, example here
            methods: {
                next() {
                    this.$refs.slick.next();
                },
                prev() {
                    this.$refs.slick.prev();
                },
                reInit() {
                    // Helpful if you have to deal with v-for to update dynamic lists
                    this.$nextTick(() => {
                        this.$refs.slick.reSlick();
                    });
                }
            }
        });
    }
};



// WEBPACK FOOTER //
// ./src/mixed-components/Entrances.js